// extracted by mini-css-extract-plugin
export var container = "_kr-0";
export var segment = "_kr-2";
export var segmentActive = "_kr-3";
export var track = "_kr-1";